import { ReactNode } from 'react'
import { usePermissions } from './usePermissions'
import { PermissionString } from './types'

interface Props {
  permission: PermissionString | PermissionString[]
  children: (isAllowed: boolean) => ReactNode
  // Allows the permission array to be either an AND or an OR depending on this flag
  needsEveryPermission?: boolean
}

export const Protected = ({
  permission,
  children,
  needsEveryPermission = false
}: Props) => {
  const { can } = usePermissions()

  if (Array.isArray(permission)) {
    if (needsEveryPermission) {
      return children(permission.every(p => can(p)))
    }

    return children(permission.some(p => can(p)))
  }

  return children(can(permission))
}
